import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppRedirectResolver {
    private translateService = inject(TranslateService);

    resolve(route: ActivatedRoute, router: Router) {
        let url = (route.data as any).externalUrl;
        const translatableUrl = (route.data as any).translatableUrl;

        if (translatableUrl) {
            url = this.translateService.instant(translatableUrl);
        }

        window.location.href = url;
    }
}
